/**
 * Global game constants (RFC §7). Portrait-only: the authoring frame is the
 * highest-iPhone-native resolution (ADR-001 ruling) — art renders 1:1 crisp
 * on a Pro Max and Scale.FIT downscales everywhere else. Save/tick constants
 * live in src/data/tunables.ts, not here.
 */

export const GAME = {
  /** Logical/authoring resolution — 1320×2868 (iPhone Pro Max native). */
  width: 1320,
  height: 2868,
} as const;

/**
 * Hero banner band (office scene). The band is drawn full canvas WIDTH in
 * Phaser; ui/dom.ts adds DOM "wings" that continue the teal fill + charcoal
 * top/bottom rules out to the true screen edges on any screen wider than the
 * FIT-scaled canvas (desktop, non-Pro-Max aspect). Shared here so the wings
 * stay locked to the canvas band — one source of truth for y / height / rule.
 */
export const HERO = {
  /** Top of the band, logical px. */
  y: 166,
  /** Band height, logical px. */
  h: 400,
  /** Charcoal top/bottom rule thickness, logical px. */
  border: 11,
  /** Plain-teal safety margin reserved at the band's L/R edges (logical px).
   *  The sunburst stops short of it, and the DOM wings extend the band by AT
   *  MOST this much past the canvas — a bounded bleed, not full-letterbox. */
  edgeSafe: 100,
  /** Corner radius for the wings' rounded outer caps (logical px). */
  radius: 46,
} as const;

/** Layout anchors shared by both floor scenes (logical px). */
export const LAYOUT = {
  /** Where characters' feet sit. */
  floorY: 2150,
  /** Scene headline band. */
  titleY: 420,
} as const;
